<template>
  <v-app id='inspire'>
      <v-content>
        <v-dialog v-model="dialog" scrollable persistent max-width="1100px">
          <v-card>
            <v-toolbar dark color="primary">
              <v-toolbar-title><h4>Información del documento por QR</h4></v-toolbar-title>
              <v-spacer></v-spacer>
              <v-btn icon dark @click="dialog = false, limpiar()">
                <v-icon>close</v-icon>
              </v-btn>
            </v-toolbar>
            <div style="padding: 15px;">
              <v-layout wrap>
                <v-flex sm12 md12>
                  <h3 v-if="entidad.length > 0 && entidad[0].organizacionSignatario">El siguiente documento fue emitido por la <strong>{{ entidad[0].organizacionSignatario }}</strong></h3>
                  Datos del/los Firmante(s):
                  <v-icon v-if="this.tipoMensaje === 'success'" color="green" right>check_circle</v-icon>
                  <v-icon v-if="this.tipoMensaje === 'warning'" color="red" right>block</v-icon>
                  <ul>
                    <div v-for="item in firmanteEntidad" v-bind:key="item.id">
                      <v-layout wrap>
                        <v-flex sm12 md6>
                          <h4><strong>{{item.signatario}}</strong></h4>
                        </v-flex>
                        <v-flex sm12 md6>
                          <h4><strong>{{item.entidad}}</strong></h4>
                        </v-flex>
                      </v-layout>
                    </div>
                  </ul>
                </v-flex>
              </v-layout>
            </div>
            <v-divider></v-divider>
              <v-card-text style="height: 1100px;">
                <pdf-view
                  v-if="this.dataPdfBase64"
                  :data="dataPdfBase64"
                  :storage="2"
                  :url="url"
                ></pdf-view>
               <v-card-actions>
              <v-spacer></v-spacer>
                <v-btn color="error" text @click="dialog = false, limpiar()"><v-icon>backspace</v-icon>&nbsp;Ir página principal</v-btn>
              </v-card-actions>
              </v-card-text>
          </v-card>
        </v-dialog>
      </v-content>
  </v-app>
</template>

<script>
import PdfView from '@/common/util/PdfView.vue';

export default {
  components: {
    PdfView
  },
  created () {
    const req = this.$route.query.dmFsaWRhY2lvbmNlcnRpZmljYWRv;
    if (req) {
      const buff = Buffer.from(req, 'base64');
      const text = buff.toString('ascii');
      if (text.search(':') > 0) {
        const [codigoControl, dateFormatted] = text.split(':');
        this.dateFormatted = dateFormatted;
        this.codigoControl = codigoControl;
        this.buscar();
      }
    }
  },
  data: () => ({
    dialog: false,
    loader: null,
    loadingUpload: false,
    url: 'http://localhost/api/download/pdf',
    menu: false,
    date: new Date().toISOString().substr(0, 10),
    dRules: [v => !!v || 'Este campo es requerido'],
    validacion: false,
    pdfFile: '',
    fileName1: '',
    fileBase64: '',
    dataPdfBase64: '',
    dateFormatted: null,
    codigoControl: '',
    firmanteEntidad: [],
    tipoMensaje: '',
    entidad: []
  }),
  methods: {
    buscar () {
      if (this.dateFormatted && this.codigoControl) {
        const params = { fecha_recepcion: this.dateFormatted, control_cge: this.codigoControl };
        this.$service.post(`djbr_registro/validar_control`, params).then(response => {
          if (response) {
            this.tipoMensaje = response.err_existente === 0 ? 'success' : 'error';
            this.$message[this.tipoMensaje](response.err_mensaje);
            // base64 del id de archivo para enviar al servicio
            if (response.id_archivo_dig_cert) {
              const paramsArchivo = { value: Buffer.from(`value:${response.sha256_cert}:${response.id_archivo_dig_cert}`).toString('base64') };
              this.$storage.set('token', process.env.TOKEN_EXTERNO);
              this.$service.post(`djbr_registro/validar_documento`, paramsArchivo).then(response => {
                this.$storage.remove('token');
                if (response) {
                  let archivoValidado = response.documento;
                  this.$service.post(`system/validar`, {file: `data:application/pdf;base64,${archivoValidado}`}).then(response => {
                    if (response) {
                      this.tipoMensaje = response.verificacion && response.certificado.length > 0 ? 'success' : 'warning';
                      this.tipoMensaje = response.certificado.length === 0 ? 'error' : this.tipoMensaje;
                      this.$message[this.tipoMensaje](response.message);
                      this.dataPdfBase64 = archivoValidado.replace('data:application/pdf;base64,', '');
                      this.entidad = response.certificado;
                      const certs = response.certificado;
                      let firmanteEntidadArr = [];
                      let firmanteEntidadData = {};
                      let i = 0;
                      certs.forEach(function (cert) {
                        firmanteEntidadData = { id: i, signatario: cert.nombreComunSubject, entidad: '' };
                        firmanteEntidadData = cert.organizacionSubject ? { id: i, signatario: cert.nombreComunSubject, entidad: cert.organizacionSubject } : firmanteEntidadData;
                        firmanteEntidadArr.push(firmanteEntidadData);
                        i = i + 1;
                      });
                      this.dialog = true;
                      this.validacion = true;
                      this.firmanteEntidad = firmanteEntidadArr;
                    } else {
                      this.$message['warning']('No es posible realizar la validación');
                    }
                  }).catch(error => {
                    console.error(error);
                  });
                }
              }).catch(error => {
                console.error(error);
                this.$storage.remove('token');
              });
            }
          }
        }).catch(error => {
          console.error(error);
          this.$storage.remove('token');
        });
      } else {
        this.$message['warning']('Es necesario el código de control y la fecha de recepción');
      }
    },
    limpiar () {
      this.$router.push('/');
    },
    formatDate (date) {
      if (!date) return null;
      const [year, month, day] = this.date.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate (date) {
      if (!date) return null;
      const [day, month, year] = date.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
  },
  computed: {
    computedDateFormatted () {
      return this.formatDate(this.date);
    },
    computedDateFormattedF () {
      return this.formatDateF(this.dateF);
    }
  },
  watch: {
    loader () {
      const l = this.loader;
      this[l] = !this[l];
      setTimeout(() => (this[l] = false), 3000);
      this.loader = null;
    },
    date (val) {
      this.dateFormatted = this.formatDate(this.date);
    }
  }
};
</script>

<style lang='scss'>
.pdf-view .pdf-view-actions .pdf-view-buttons .visible {
  visibility: hidden !important;
}
</style>



// WEBPACK FOOTER //
// src/components/djbrd/Validar.vue